import React from "react";
import {
    Row, Col, Card, CardHeader, CardBody, Table, Alert, Button, Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import AlertExpire from "../../../components/AlertExpire";
import { LoadingSpinner } from "../../../components";
import { connect } from 'react-redux';
import { GetCompanyList, deleteCompany } from "../../../api/CompanyInfo";
import NewCompanyEntryDetail from "./NewCompanyEntryDetail";
import CompanyInfoEntryDetail from "./CompanyInfoEntryDetail";
import { Pagination } from "../../../components/Pagination/index";


class CompanyEntryList extends React.Component {

    static routeName = '/info/company';

    state = {
        data: [],
        errorMessage: "",
        successMessage: "",
        deleteModal: -1,
        isLoading: false,
        isExpired: false,

        currentPage: 1,
        totalPage: 0,
        rowPerPage: 10,
        totalRecord: 0,
    }
    componentDidMount() {
        this.loadData();
    }

    async loadData() {
        this.setState({ isLoading: true })
        const {currentPage,rowPerPage,totalPage,totalRecord} = this.state;
        const resdata = await GetCompanyList(currentPage,rowPerPage);
        if (resdata === 401) {
            this.setState({ isExpired: true });
        } else {
            this.setState({
                data: resdata.records,
                totalRecord: resdata.totalCount,
                totalPage: Math.ceil(resdata.totalCount / this.state.rowPerPage),
                isLoading: false,
            });
        }
    }

    toggle(index) {
        let { deleteModal } = this.state;
        this.setState({ deleteModal: deleteModal === index ? -1 : index });
    }

    handleEdit(rowObj) {
        this.props.history.push({ pathname: `${CompanyInfoEntryDetail.routeName}/${rowObj.companyId}` });
    }

    onClickPageNumber(e, index) {
        e.preventDefault();
        this.setState({ currentPage: index }, () => this.loadData());
      }
    
      onClickRowPerPage(e) {
        this.setState({
          currentPage: 1,
          rowPerPage: Number(e.target.value),
          totalPage: Math.ceil(this.state.data.length / Number(e.target.value)),
        }, () => this.loadData());
      }

    async handleDelete(rowObj) {
        this.toggle();
        console.log('rowObj', rowObj);
        const res = await deleteCompany(rowObj);
        if (res && res.status === true) {
            this.loadData();
            this.setState({
                successMessage: "Company has been delete successfully."
            });
        }
        else if (res === 401) {
            this.setState({ isExpired: true })
        } else if (res.message === "NOT" && res.status === false) {
            this.setState({
                errorMessage: "Cannot delete! It is currently being used by another process."
            })
        }
        else {
            this.setState({
                errorMessage: "Error While Deleting!"
            })
        }
    }

    renderList() {
        let filteredData = this.state.data;

        if (filteredData.length === 0) {
            return <tr><td colSpan="7" className="text-center" >No data to show</td></tr>;
        }

        return this.state.data.map((row, index) => {

            return (
                <tr key={row.companyId}>
                    <td>{row.companyName}</td>
                    <td>{row.phoneNb}</td>
                    <td>{row.contactPerson === null ? '(empty)' : (row.contactPerson)}</td>
                    <td>{row.contactPhoneNb === null ? '(empty)' : (row.contactPhoneNb)}</td>
                    <td>
                        <span onClick={() => this.handleEdit(row)} style={{ cursor: "pointer" }}><i className="fa fa-pencil-square fa-lg" style={{ color: "green" }}></i></span>
                        &nbsp;
                        <span onClick={() => this.toggle(index)} style={{ cursor: "pointer" }}>
                            <i className="fa fa-trash-o fa-lg" aria-hidden="true" style={{ color: "red" }}></i>
                        </span>
                    </td>
                    <Modal isOpen={this.state.deleteModal === index} toggle={() => this.toggle(index)}
                        className={'modal-danger '}>
                        <ModalHeader toggle={() => this.toggle(index)}>Delete Item</ModalHeader>
                        <ModalBody>
                            <p>
                                Are you sure want to delete <strong>{row.productName}</strong>
                            </p>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="danger" onClick={() => this.handleDelete(row)}>Yes</Button>
                            <Button color="secondary" onClick={() => this.toggle(index)}>No</Button>
                        </ModalFooter>
                    </Modal>

                </tr>
            );
        });
    }
    render() {
        const {totalRecord,totalPage,currentPage,rowPerPage} = this.state;
        return (
            <Row >
                <Col xs="12" lg="12">
                    <Card>
                        {this.state.isLoading && <LoadingSpinner />}
                        {this.state.isExpired && <AlertExpire />}
                        <CardHeader>
                            Company List
                            {this.props.auth.roleName.toLowerCase() === 'portaladmin' ?
                                <Button color="primary" className="float-right" onClick={() => this.props.history.push({ pathname: NewCompanyEntryDetail.routeName })} >New Company</Button>
                                :
                                ''
                            }
                        </CardHeader>
                        <CardBody>
                            {this.state.errorMessage !== "" &&
                                <Alert toggle={() => this.setState({ errorMessage: "" })} color="danger">{this.state.errorMessage}</Alert>
                            }
                            {this.state.successMessage !== "" &&
                                <Alert toggle={() => this.setState({ successMessage: "" })} color="success">{this.state.successMessage}</Alert>
                            }

                            <Table className="table-sm" responsive striped>
                                <thead>
                                    <tr className="text-center">
                                    </tr>
                                    <tr>
                                        <th bgcolor="#C8F4F8">Name</th>
                                        <th bgcolor="#C8F4F8">Phone Number</th>
                                        <th bgcolor="#C8F4F8">Contact Person</th>
                                        <th bgcolor="#C8F4F8">Contact Phone Number</th>
                                        <th bgcolor="#C8F4F8"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.renderList()}
                                </tbody>
                            </Table>
                            {totalRecord > 0 ?
                                <Pagination
                                    className=""
                                    totalPage={totalPage}
                                    currentPage={currentPage}
                                    rowPerPage={rowPerPage}
                                    totalRecord={totalRecord}
                                    besideRangeDisplayed={2}
                                    onClickPageNumber={(e, index) => this.onClickPageNumber(e, index)}
                                    onClickRowPerPage={(e) => this.onClickRowPerPage(e)}
                                /> : ""
                            }
                        </CardBody>
                    </Card>
                </Col>
            </Row>)
    }
}
function mapStateToProps(state) {
    return { auth: state.auth };
}
export default connect(mapStateToProps)(CompanyEntryList);